import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimeExporter  {
    _originalTypeClassName = "zERP.BO.OvertimeExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimeExporter.translate = translateService;
}
this.OvertimeExporterKey = null;
this._key = this.OvertimeExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _OvertimeExporterKey:any;
get OvertimeExporterKey(): any {
    return this._OvertimeExporterKey;
  }
set OvertimeExporterKey(value: any) {
    this._OvertimeExporterKey = value;
    this._key = value;
  }

static ExecuteGetOvertimeTotalValue(data: any,key: any): any{console.info("Retrieving sum for overtimeTypeCode: " + key);
let otSum = data?.OvertimeSums?.linq?.where((l) => l?.Key == key)?.firstOrDefault(null);
console.info("OT sum for overtimeTypeCode " + key + " is " + Joove.Common.safeNumber(otSum?.HoursSum));
let value = 0;
if (otSum != null) {return Joove.Common.cast(otSum?.HoursSum, "number");}
return value;
}
static ExecuteGetOvertimeValue(data: any,overtimeTypeCode: any): any{let req = data?.OvertimeRequests?.linq?.where((l) => l?.OvertimeType?.Code == overtimeTypeCode)?.firstOrDefault(null);
let value = 0;
if (req != null) {try {value = Joove.Common.cast(req?.RequestedHours, "number");}catch (e) {console.error(e?.message);throw Error(e);}}
return value;
}
static ExecuteGetPeriodOvertimeTotalValue(data: any,overtimeTypeCode: any): any{console.info("PERIOD --- Retrieving sum for overtimeTypeCode: " + overtimeTypeCode);
let otSum = data?.OvertimeSums?.linq?.where((l) => l?.Key == overtimeTypeCode)?.firstOrDefault(null);
console.info("PERIOD --- OT sum for overtimeTypeCode " + otSum?.Key + " is " + Joove.Common.safeNumber(otSum?.HoursSum));
let value = 0;
if (otSum != null) {return Joove.Common.cast(otSum?.HoursSum, "number");}
return value;
}
static GetCollectionVariables(otTable: any): any{let empty = [];
let vars = new window['Map']();
let overtimesChildren = [];
overtimesChildren?.add({
Name: "DATE",Description: "Ημερομηνία",}
);
overtimesChildren?.add({
Name: "SUM_OVERTIMES",Description: "Σύνολο",}
);
overtimesChildren?.add({
Name: "EMPLOYEE_NAME",Description: "Όνομα Υπαλλήλου",}
);
overtimesChildren?.add({
Name: "EMPLOYEE_CODE",Description: "Κωδικός Υπαλλήλου",}
);
vars.set({
Name: "OVERTIMES",Description: "Υπερωρίες",IsCollection: true,Children: overtimesChildren,}
, Joove.Common.cast(otTable?.OvertimesLines, "System.Collections.List"));
return vars;
}
static GetFunctions(): any{let functions = [];
functions?.add(Domain.ExcelExporterFunction.Fill("GET_OVERTIME", "Υπερωρία ανα Τύπο", ["Κωδικός Τύπου Υπερωρίας"], ["decimal"], [""]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_OVERTIME_TOTAL", "Άθροισμα Υπερωριών ανα Τύπο", ["Κωδικός Τύπου Υπερωρίας"], ["decimal"], [""]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_PERIOD_TOTAL", "Άθροισμα Υπερωριών Περιόδου ανα Τύπο", ["Κωδικός Τύπου Υπερωρίας"], ["decimal"], [""]));
return functions;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any,funcInvocation: any): any{let resp;
resp.Value = "";
let data = Joove.Common.cast(item, "Domain.OvertimesLine");
if (funcInvocation != null) {switch (funcInvocation?.Name) {case "GET_OVERTIME":
{
resp.Value = Domain.OvertimeExporter.ExecuteGetOvertimeValue(data, funcInvocation?.Arguments?.linq?.where()?.firstOrDefault(null)?.Value);resp.VType = Domain.ExcelExporterVariableType.Hours;let value = Joove.Common.cast(resp.Value, "number");data.SumOvertimes = Joove.Common.safeNumber(data?.SumOvertimes) + Joove.Common.safeNumber(value);console.warn("edoo overtime 23: " + Joove.Common.safeNumber(data?.SumOvertimes));return resp;}
case "GET_OVERTIME_TOTAL":
{
resp.Value = Domain.OvertimeExporter.ExecuteGetOvertimeTotalValue(data?.OvertimesTable, funcInvocation?.Arguments?.linq?.where()?.firstOrDefault(null)?.Value + "_" + data?.Employee?.Employee?.Code);resp.VType = Domain.ExcelExporterVariableType.Hours;let value = Joove.Common.cast(resp.Value, "number");data.SumOvertimes = Joove.Common.safeNumber(data?.SumOvertimes) + Joove.Common.safeNumber(value);console.warn("edoo overtime 31: " + Joove.Common.safeNumber(data?.SumOvertimes));return resp;}
case "GET_PERIOD_TOTAL":
{
resp.Value = Domain.OvertimeExporter.ExecuteGetPeriodOvertimeTotalValue(data?.OvertimesTable, funcInvocation?.Arguments?.linq?.where()?.firstOrDefault(null)?.Value);resp.VType = Domain.ExcelExporterVariableType.Hours;let value = Joove.Common.cast(resp.Value, "number");data.SumOvertimes = Joove.Common.safeNumber(data?.SumOvertimes) + Joove.Common.safeNumber(value);console.warn("edoo overtime 37: " + Joove.Common.safeNumber(data?.SumOvertimes));return resp;}
}}
if (collectionName == "OVERTIMES") {varName = varName?.toUpperCase();console.info("varName: " + varName);switch (varName) {case "DATE":
{
resp.Value = data?.OvertimeDate;return resp;}
case "SUM_OVERTIMES":
{
console.warn("edoo overtime 48 ");resp.Value = data?.SumOvertimes;console.warn("edoo overtime 50 " + resp.Value);return resp;}
case "EMPLOYEE_NAME":
{
resp.Value = data?.Employee?.Employee?.Fullname;console.info("Name --- resp.Value: " + resp.Value);return resp;}
case "EMPLOYEE_CODE":
{
resp.Value = data?.Employee?.Employee?.Code;console.info("Code --- resp.Value: " + resp.Value);return resp;}
default:
{
console.error("I ended up in default case of switch in ResolveCollectionItem of OvertimeExporter...");break;
}
}}
console.warn("collection '" + collectionName + "' - variable '" + varName + "' not handled");
return resp;
}
static ResolveFunctionInvocation(funcInvocation: any,context: any): any{let data = Joove.Common.cast(context, "Domain.OvertimesTable");
switch (funcInvocation?.Name) {case "GET_OVERTIME_TOTAL":
{
return Domain.OvertimeExporter.ExecuteGetOvertimeTotalValue(data, funcInvocation?.Arguments?.linq?.where()?.firstOrDefault(null)?.Value);}
case "GET_PERIOD_TOTAL":
{
return Domain.OvertimeExporter.ExecuteGetPeriodOvertimeTotalValue(data, funcInvocation?.Arguments?.linq?.where()?.firstOrDefault(null)?.Value);}
}
console.error("Unresolved function name: " + funcInvocation?.Name);
return funcInvocation?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OvertimeExporterKey == null || $this.OvertimeExporterKey == 0;
            }


}